import React from "react";
import { useCreditDispatch } from "../../stores/credit/credit.store";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { UserForm } from "./UserForm";
import { UserInterface } from "../../interfaces/credit/user.interface";
import { changeConfirmedPhone, nextPage, saveUser, setConfirmedPhone } from "../../stores/credit/credit.reducer";
import { ConfirmCode } from "../ConfirmCode";
import { isVerificationPhoneThunk } from "../../stores/credit/thunks/is-verification-phone.thunk";
import { useCreditSelector } from "../../stores/product/product.store";

export const Second = () => {
    const confirmedPhone = useCreditSelector((state: CreditState) => state.confirmedPhone);
    const temporaryPhone = useCreditSelector((state: CreditState) => state.temporaryPhone);
    const isShowConfirmedPhone = useCreditSelector((state: CreditState) => state.isShowConfirmedPhone);
    const dispatch = useCreditDispatch();

    const submit = (user: UserInterface) => {
        dispatch(saveUser(user));
        if(confirmedPhone !== user.phone) {
            dispatch(isVerificationPhoneThunk(user.phone));
        } else {
            dispatch(nextPage())
        }
    }

    const changeNumber = () => {
        dispatch(changeConfirmedPhone())
    }

    const completeCode = (phone: string, code: string) => {
        dispatch(setConfirmedPhone({ phone, code }));
        dispatch(nextPage());
    }

    return (
       <>
           { isShowConfirmedPhone ? <ConfirmCode phoneNumber={ temporaryPhone } onChangeNumber={ changeNumber } onCompleteCode={ completeCode } /> : <UserForm onSubmit={ submit } /> }
       </>
    )
}